import styled from "styled-components";

export const Container = styled.div`
  width: 50vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: rgba(179, 13, 13, 1);
`;